import { InputCellType } from '../../../../../../types/inputform.d';
import { useEffect } from 'react';

const InputCell = ({ value, onChange: handleChange, onKeyDown }: InputCellType) => {
  return (<input type="number" lang="en" placeholder="0.00" step="0.01" autoFocus onChange={(event) => { handleChange && handleChange(event?.target?.value) }} value={(value && String(value).includes('=')) ? '0.00' : value} onKeyDown={onKeyDown} />)
}

export default InputCell;
